import * as React from 'react';
import * as styles from './MotivationPopupWrapper.css';

export const MotivationPopupWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
